import { createContext, useContext, useState, ReactNode } from "react";
import dayjs from "dayjs";

interface UrbanAnimationState {
  frameElapsedS: number | null;
  selectedIgnitionInfo: any | null;
  currentFrame: number | null;
  timestamps: dayjs.Dayjs[];
}

interface UrbanAnimationContextValue {
  frameElapsedS: number | null;
  selectedIgnitionInfo: any | null;
  currentFrame: number | null;
  timestamps: dayjs.Dayjs[];
  setUrbanAnimation: (state: UrbanAnimationState) => void;
}

const UrbanAnimationContext = createContext<UrbanAnimationContextValue>({
  frameElapsedS: null,
  selectedIgnitionInfo: null,
  currentFrame: null,
  timestamps: [],
  setUrbanAnimation: () => {},
});

export const UrbanAnimationProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState<UrbanAnimationState>({
    frameElapsedS: null,
    selectedIgnitionInfo: null,
    currentFrame: null,
    timestamps: [],
  });

  return (
    <UrbanAnimationContext.Provider value={{ ...state, setUrbanAnimation: setState }}>
      {children}
    </UrbanAnimationContext.Provider>
  );
};

export const useUrbanAnimation = () => useContext(UrbanAnimationContext);
